import '.s{overflow:hidden;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.b1{height:4rem;}.ssr-plugin'
import { useMemo } from 'react'
import stichtingDoenImage from '@app/assets/images/steward-ownership/steward-partners/stichting-doen.png'
import fairCapitalImage from '@app/assets/images/steward-ownership/steward-partners/fair-capital.jpg'
import momkaiImage from '@app/assets/images/steward-ownership/steward-partners/momkai.png'
import weAreStewardsImage from '@app/assets/images/steward-ownership/steward-partners/we-are-stewards.jpg'
import zebraLegalImage from '@app/assets/images/steward-ownership/steward-partners/zebra-legal.png'

import { ScrollingBanner } from '@app/components/core/scrollingBanner/ScrollingBanner'
import { styled } from 'inlines'
import { Image } from '@app/components/core/image/Image'

const partners = [
  {
    imageAlt: 'fair capital',
    imageSrc: fairCapitalImage,
  },
  {
    imageAlt: 'stichting doen',
    imageSrc: stichtingDoenImage,
  },
  {
    imageAlt: 'momkai',
    imageSrc: momkaiImage,
  },
  {
    imageAlt: 'we are stewards',
    imageSrc: weAreStewardsImage,
  },
  {
    imageAlt: 'zebra.legal',
    imageSrc: zebraLegalImage,
  },
]

export const OurStewardPartners = () => {
  const partnersMapped = useMemo(
    () =>
      partners.map((partner, index) => (
        <Image
          key={index}
          src={partner.imageSrc}
          alt={partner.imageAlt}
          resizeHeight={64}
          style={{
            height: '4rem',
            width: 'auto',
            maxWidth: '20rem',
            objectFit: 'contain',
          }}
        />
      )),
    [],
  )
  return (
    <div className="s a6 b1">
      <ScrollingBanner
        gap="4rem"
        style={{ position: 'absolute', left: 0, right: 0 }}
      >
        {partnersMapped}
        {partnersMapped}
      </ScrollingBanner>
    </div>
  )
}
